module.exports = __webpack_public_path__ + "img/0d9b46e2bfc292d6653d5ac0cf25c7ab.png";